import React, { PureComponent } from 'react';
import nonStandardAttrs from './nonStandardAttributes';
import standardAttrs from './standardAttributes';
import './Attributes.css';

export default class Attribute extends PureComponent {
  render() {
    const { attributeName, appApi } = this.props;
    const Attribute =
      nonStandardAttrs[attributeName] ||
      standardAttrs[appApi.config.getAttribute(attributeName).type];
    if (!Attribute)
      return (
        <div>{`Missing render method for attribute ${attributeName}`}</div>
      );
    return <Attribute {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/index.js